import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-redirect-social-dialog',
  templateUrl: './redirect-social-dialog.component.html',
  styleUrl: './redirect-social-dialog.component.scss'
})
export class RedirectSocialDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<RedirectSocialDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { provider: string }
  ) {}

}
